import React, { useState, useRef, useEffect, useContext } from "react";
import { RadioContext } from "../../services/RadioProvider";
import usePlayerUtils from "../../hooks/usePlayerUtils";
import "./RadioPlayerCoverFrame.css";

export default function RadioPlayerCoverFrame() {
  const { nowPlaying } = useContext(RadioContext);
  const { currentTrack: listeningTrack } = usePlayerUtils();
  const coverRef = useRef(null);

  const [initialTrack, setInitialTrack] = useState(null);

  const coverEffects = ["d-fade", "d-slide", "d-zoom"];
  const getRandomEffect = () => coverEffects[Math.floor(Math.random() * coverEffects.length)];

  useEffect(() => {
    const firstTrack = nowPlaying?.history?.[0];
    if (firstTrack) {
      setInitialTrack(firstTrack);
    }
  }, [nowPlaying]);

  const currentTrack = listeningTrack || initialTrack;

  useEffect(() => {
    if (coverRef.current && currentTrack?.coverUrl) {
      coverRef.current.className = "d-cover " + getRandomEffect();
    }
  }, [currentTrack?.coverUrl]);

  const artist = currentTrack?.artist || "";
  const songTitle = currentTrack?.title || "";
  const coverUrl = currentTrack?.coverUrl || "";

  const modifiedCoverUrl = coverUrl.includes("default")
    ? coverUrl.replace(".png", "-mid.png")
    : coverUrl;

  return (
    <div className="d-frame-main">
      <div className="d-title-info">
        <div className="d-text"></div>
      </div>
      <div className="d-outer-frame">
        <div className="d-cover-frame">
          <div id="d-frame" style={{ backgroundImage: `url(${modifiedCoverUrl})` }}></div>
          {coverUrl && <img ref={coverRef} className="d-cover d-fade" src={modifiedCoverUrl} alt="Cover" />}
          <div className="d-title">
            <div className="underline"></div>
            <div className="d-title-artist">{artist}</div>
            <div className="d-title-title">{songTitle}</div>
            <div className="underline"></div>
          </div>
        </div>
      </div>
    </div>
  );
}